import React from "react";
import Header from "../../Header";
import Footer from "../../components/Footer";
import service1 from "../../assets/services-1";
import service2 from "../../assets/services-2";
import service3 from "../../assets/services-3";

const Services = () => {
  return (
    <div className="bg-white w-full font-inter">
      <Header />

      {/* ================= HERO ================= */}
      <section className="relative bg-[#FFF0DC] py-24 px-6 md:px-12 text-center overflow-hidden">
        <div className="absolute -top-10 -left-10 w-60 h-60 bg-orange-200 opacity-25 rounded-full blur-3xl"></div>
        <div className="absolute top-20 -right-10 w-72 h-72 bg-orange-300 opacity-20 rounded-full blur-3xl"></div>

        <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 relative z-10">
          Our <span className="text-orange-500">Services</span>
        </h1>
        <p className="text-gray-600 max-w-3xl mx-auto mt-4 text-lg">
          A quick overview of what we offer to help you improve your emotional 
          and mental wellbeing.
        </p>
      </section>

      {/* ================= SERVICE CARDS ================= */}
      <section className="max-w-7xl mx-auto py-20 px-6 md:px-12">
        <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
          What We Provide
        </h2>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">

          {/* Card 1 — Online Therapy */}
          <div className="bg-white shadow-lg rounded-2xl p-8 hover:shadow-xl transition-all">
            <img
              src={service1}
              alt="Online Therapy"
              className="w-full h-40 object-cover rounded-xl mb-5"
            />
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Online Therapy</h3>
            <p className="text-gray-600 text-sm">
              Safe and private online sessions with certified therapists.
              Full module becomes available after login.
            </p>
          </div>

          {/* Card 2 — Mental Health Support */}
          <div className="bg-white shadow-lg rounded-2xl p-8 hover:shadow-xl transition-all">
            <img
              src={service2}
              alt="Mental Health Support"
              className="w-full h-40 object-cover rounded-xl mb-5"
            />
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Mental Health Support</h3>
            <p className="text-gray-600 text-sm">
              Personalized emotional wellness guidance. Login to access full features.
            </p>
          </div>

          {/* Card 3 — Booking */}
          <div className="bg-white shadow-lg rounded-2xl p-8 hover:shadow-xl transition-all">
            <img
              src={service3}
              alt="Consultation Booking"
              className="w-full h-40 object-cover rounded-xl mb-5"
            />
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Consultation Booking</h3>
            <p className="text-gray-600 text-sm">
              Book sessions with experts instantly. Full booking system works after login.
            </p>
          </div>

        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <p className="text-gray-600 text-lg mb-4">
            Want to access full therapy, booking, and dashboard features?
          </p>
          <button className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-xl text-lg shadow-lg transition-all">
            Login to Continue
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Services;
